<template>
  <div
    class="main-index-container"
    v-bind:class="{ showedInfo: showInfo, isMap: isMap }"
  >
    <div class="main-container" v-bind:style="{ transform: transform }">
      <div class="top-promo">
        <div class="top-promo-holder">
          <span class="logo">
            <img src="../images/nfmlogo.svg" alt="nfm logo" />
          </span>
          <span class="logo-text" v-text="$ml.get('myLogoText')"></span>
        </div>
        <div class="map-btn-box" @click="tapMap" v-touch:swipe.bottom="tapMap">
          <div class="map-btn" v-if="!isMap">
            <span class="icon"></span>
            <span
              class="text"
              v-text="$ml.with('VueJS').get('mapTitle')"
            ></span>
          </div>
          <div class="map-icon-arrow">
            <i class="icon-map-arrow"></i>
          </div>
        </div>
      </div>
      <div class="map-section">
        <gmap-map
          ref="mainMap"
          :center="startLocation"
          :zoom="6"
          map-type-id="roadmap"
          style="width: 100%; height: 100%"
          :options="{
            zoomControl: false,
            scaleControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            disableDefaultUi: false
          }"
        >
          <gmap-marker
            v-for="(item, key) in coordinates"
            :key="key"
            :position="getPosition(item)"
            :clickable="true"
            :icon="getMarkers(key)"
            @click="toggleInfo(item, key)"
          ></gmap-marker>
        </gmap-map>
        <transition name="map-info-window-slide">
          <div
            class="map-info-window"
            :opened="infoOpened"
            :position="infoPosition"
            v-if="infoOpened"
          >
            <div class="city-info">
              <div class="city-name">{{ selectedCity }}</div>
              <div class="city-name">{{ selectedAdress }}</div>
              <div class="city-phone">{{ selectedPhone }}</div>
              <div class="city-email">{{ selectedEmail }}</div>
              <div class="city-location">{{ selectedLocation }}</div>
              <!--              <button v-on:click="linkCordinat(infoPosition.lat, infoPosition.lng)" class="btn btn-full-width btn-main">{{$ml.with('VueJS').get('getDirections')}}</button>-->
              <a
                v-bind:href="
                  'https://www.google.com/maps/dir/?api=1&destination=' +
                    infoPosition.lat +
                    ',' +
                    infoPosition.lng
                "
                target="_blank"
                class="btn btn-full-width btn-main"
                >{{ $ml.with("VueJS").get("getDirections") }}</a
              >
              <div class="map-btn-close-holder">
                <button
                  class="map-btn-close"
                  @click="closeInfoWindow()"
                  v-touch:swipe.top="closeInfoWindow"
                ></button>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <nav class="main-menu-section">
        <a href="#/Catalog/0">
          <span class="icon icon-catalog">icon</span>
          <span class="text" v-text="$ml.with('VueJS').get('catalogTitle')">
            Каталог
            <br />техники
          </span>
        </a>
        <a href="#/Search">
          <span class="icon icon-spare-part">icon</span>
          <span class="text" v-text="$ml.with('VueJS').get('sparePartTitle')">
            Запасные
            <br />части
          </span>
        </a>
        <a href="#/ServiceRequests">
          <span class="icon icon-order-services">icon</span>
          <span
            class="text"
            v-text="$ml.with('VueJS').get('orderServicesTitle')"
          >
            Заявки на
            <br />сервис
          </span>
        </a>
        <a href="#/Teaching">
          <span class="icon icon-teaching">icon</span>
          <span class="text" v-text="$ml.with('VueJS').get('teachingTitle')">
            Обучение
            <br />персонала
          </span>
        </a>
      </nav>
      <div
        class="information-btn-box"
        @click="tapInformation"
        v-touch:swipe.bottom="tapInformation"
        v-touch:swipe.top="tapInformation"
      >
        <div class="information-btn" v-bind:class="{ showedInfo: showInfo }">
          <span class="icon"></span>
          <span
            class="text"
            v-text="$ml.with('VueJS').get('informationTitle')"
          ></span>
        </div>
      </div>
    </div>
    <div
      class="phone-section"
      v-touch:tap="tapHandler"
      v-touch:swipe.left="swipeLeftHandler"
      v-touch:swipe.right="swipeRightHandler"
      v-bind:class="{ opened: isActive }"
    >
      <span class="phone-btn">tap</span>
      <div class="phone-panel">
        <div class="phone-panel-items">
          <div class="phone-panel-item">
            <div class="phone-panel-title">
              {{ $ml.with("VueJS").get("phone_new") }}
            </div>
            <a
              href="tel:+380674888880"
              style="color: #FFFFFF"
              class="phone-panel-value"
            >
              067 488 88 80
            </a>
          </div>
        </div>
        <div class="phone-panel-socials">
          <!-- <a href="https://t.me/nfmagro" class="phone-panel-socials-item">
            <i class="icon-telegram"></i>
          </a> -->
          <a
            href="https://invite.viber.com/?g2=AQBd8Fy1T3Pq9UsND0exIjRlYtHYl3wd%2FlagZ7%2BuPRmzk%2BIrD%2Fb2%2FBnWKvaLkmFf"
            class="phone-panel-socials-item"
          >
            <i class="icon-viber"></i>
          </a>
          <a
            href="https://www.facebook.com/NfmAgro"
            class="phone-panel-socials-item"
          >
            <i class="icon-messenger"></i>
          </a>
          <!-- <a
            href="https://api.whatsapp.com/send?phone=+380674888880"
            class="phone-panel-socials-item"
          >
            <i class="icon-whatsup"></i>
          </a> -->
        </div>
      </div>
    </div>
    <div
      class="information-section"
      v-bind:style="{ transform: transform }"
      ref="infoBox"
    >
      <div class="information-list">
        <a href="https://nfm.com.ua/" target="_blank" class="information-item"
          >nfm.com.ua</a
        >
        <a href="tel:0800407887" class="information-item">0 (800) 40 7887</a>
        <a
          href="#/Settings"
          class="information-item"
          v-text="$ml.with('VueJS').get('settingsTitle')"
          >Настройки</a
        >
        <a
          href="#/Personal"
          class="information-item"
          v-text="$ml.with('VueJS').get('personalTitle')"
          >Личный кабинет</a
        >
      </div>
      <div class="footer-menu">
        <a href="#/Kodeks" v-text="$ml.with('VueJS').get('codexTitle')"
          >Кодекс корпоративной этики</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { MLBuilder } from 'vue-multilanguage'
import { GET_USERS, LOG_LOGOUTS, GET_LOCATIONS } from '../helpers/requests'

export default {
  data () {
    localStorage.removeItem('search')
    let mapMarker = require('../images/ic-map-marker.svg')
    let mapMarkerActive = require('../images/ic-map-marker-active.svg')
    return {
      mapMarker,
      mapMarkerActive,
      nfm: 'https://nfm.com.ua',
      isActive: false,
      showInfo: false,
      transform: 'translateY(0)',
      heightString: 0,
      isMap: false,
      isMarkerClick: false,
      startLocation: {
        lat: 49.0384,
        lng: 33.4513
      },
      coordinates: JSON.parse(localStorage.getItem('coordinates')),
      selectedAdress: null,
      selectedCity: null,
      selectedPhone: null,
      selectedEmail: null,
      selectedLocation: null,
      infoPosition: null,
      infoOpened: false,
      infoCurrentKey: null,
      markerOptions: {
        url: mapMarker
      },
      selectedKey: null,
      selectedMarker: null,
      info: null,
      resultUser: null
    }
  },
  mounted () {
    // console.log(this.linkCordinat(this.infoPosition.lat, this.infoPosition.lng))
    this.loadDepartments()
    this.isLang(localStorage.activeItem)
    this.loadJsonUser()
    this.checkAuth()
  },
  created () {
    if (localStorage.getItem('activeItem') === '1') {
      this.resource = this.$resource('departments/ua')
    } else {
      this.resource = this.$resource('departments')
    }
  },
  computed: {
    mlmyLogoText () {
      return new MLBuilder('logoText')
    }
  },
  methods: {
    async sendLogoutLogs (errorMessage) {
      try {
        await LOG_LOGOUTS(JSON.stringify(errorMessage))
      } catch (error) {
        console.log(error.message)
      }
    },
    async loadJsonUser () {
      if (localStorage.userId) {
        this.users = await GET_USERS(localStorage.userId)
          .then(response => response.json())
          .then(response => {
            // console.log(response)
            if (!response.can_use_app) {
              this.sendLogoutLogs({
                data: `Користувач ${localStorage.userName} з id ${
                  localStorage.userId
                } не має доступу до додатку ${JSON.stringify(
                  response
                )} (Home.324)`
              })
              localStorage.clear()
              return
            }
            localStorage.setItem('userName', response.name)
            localStorage.setItem('userPhone', response.phone)
            localStorage.setItem('userEmail', response.email)
            localStorage.setItem('userRegion', response.region.name)
            localStorage.setItem('userNumber', response.egrpou)
            localStorage.setItem('userCompany', response.company_name)
          })
      }
    },
    linkCordinat (shirota, dolgota) {
      window.open(
        'https://www.google.com/maps/dir/?api=1&destination=' +
          shirota +
          ',' +
          dolgota,
        '_blank'
      )
    },
    semeMet (name, value) {
      this.$localStorage.set(name, value)
    },
    async loadDepartments () {
      await this.resource
        .get()
        .then(response => response.json())
        .then(response => {
          response.forEach(function (values, item) {
            // eslint-disable-next-line no-undef
            let phone = response[item].phone.join(', ')
            response[item].phone = phone
            // console.log(response[item].phone.join(', '))
            // console.log(item)
          })
          this.coordinates = response
          localStorage.setItem('coordinates', JSON.stringify(this.coordinates))
        })
    },
    tapHandler () {
      this.isActive ? (this.isActive = false) : (this.isActive = true)
    },
    swipeLeftHandler () {
      this.isActive = true
    },
    swipeRightHandler () {
      this.isActive = false
    },
    gettingHeight () {
      this.heightString = this.$refs.infoBox.clientHeight
    },
    tapInformation () {
      this.gettingHeight()
      // this.showInfo
      //   ? ((this.showInfo = false)
      //   (this.transform = 'translateY(0)'))
      //   : ((this.showInfo = true)
      //   (this.transform = 'translateY(-' + this.heightString + 'px)'))
      if (this.showInfo) {
        this.showInfo = false
        this.transform = 'translateY(0)'
      } else {
        this.showInfo = true
        this.transform = 'translateY(-' + this.heightString + 'px)'
      }
    },
    tapMap () {
      this.isMap = !this.isMap
    },
    getPosition: function (marker) {
      return {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng)
      }
    },
    getMarkers (key) {
      if (this.selectedKey === key) return this.mapMarkerActive
      return this.mapMarker
    },
    toggleInfo: function (marker, key) {
      this.infoPosition = this.getPosition(marker)
      // this.startLocation.lat = parseFloat(marker.lat)+1;
      // this.startLocation.lng = parseFloat(marker.lng);
      this.selectedPhone = '0 (800) 40 7887'
      if (marker.phone) {
        this.selectedPhone = marker.phone
      }

      this.selectedAdress = marker.address
      this.selectedCity = marker.city
      this.selectedEmail = 'sales@nfm.com.ua'
      this.selectedLocation = marker.full_name
      if (this.infoCurrentKey === key) {
        if (this.infoOpened) {
          this.infoOpened = false
          this.selectedKey = null
        } else {
          this.infoOpened = true
          this.selectedKey = key
        }
        // this.infoOpened
        //   ? ((this.infoOpened = false), (this.selectedKey = null))
        //   : ((this.infoOpened = true), (this.selectedKey = key))
      } else {
        this.infoOpened = true
        this.infoCurrentKey = key
        this.selectedKey = key
      }
    },
    closeInfoWindow: function () {
      this.infoOpened = false
      this.selectedKey = null
    },
    isLang: function (lang) {
      if (lang === '0') {
        this.$ml.change('ru')
      } else if (lang === '1') {
        this.$ml.change('ua')
      }
    },
    checkAuth: async function () {
      if (localStorage.userId) {
        this.users = await GET_USERS(localStorage.userId)
          .then(response => response.json())
          .then(response => {
            if (
              typeof response === 'object' &&
              Object.keys(response).length === 0
            ) {
              this.sendLogoutLogs({
                data: `Користувач ${localStorage.userName} з id ${
                  localStorage.userId
                } прийшов пустим ${JSON.stringify(response)} (Home.478)`
              })
              localStorage.clear()
            }
            if (
              typeof response.can_use_app === 'boolean' &&
              !response.can_use_app
            ) {
              this.sendLogoutLogs({
                data: `Користувач ${localStorage.userName} з id ${
                  localStorage.userId
                } не має доступу до додатку ${JSON.stringify(
                  response
                )} (Home.324)`
              })
              localStorage.clear()
            }
          })
      }
    }
  }
}
</script>
